export const sortByOrder = <
  T extends { order?: number | null | undefined; [key: string]: any },
>(
  items: T[] | undefined | null,
  key: keyof T
): T[] => {
  if (!items) return [];
  return items.sort((a, b) => {
    if (a.order === null || a.order === undefined) {
      if (b.order === null || b.order === undefined) {
        // Both are null/undefined, sort alphabetically by the specified key
        return String(a[key] || "").localeCompare(String(b[key] || ""));
      }
      return 1; // a is null/undefined, b has order
    }
    if (b.order === null || b.order === undefined) return -1; // b is null/undefined, a has order
    return a.order - b.order;
  });
};
